import api from '@pray/shared/utils/api';

export const getStudioAdmins = async ({ options = {} } = {}) => {
  const url = `/web/studio/admins/team-members`;
  const response = await api.executeGetRequest(url, {}, options);

  return response.data;
};
